import { handleHotkey } from 'polotno/canvas/hotkeys';
import { ElementType } from 'polotno/model/group-model';
import { StoreType } from 'polotno/model/store';
import { Page } from '../AdvancedEditor';
import { polotnoTypes } from '../types';
import { checkPolotnoType } from './checkPolotnoType';
import { getAvatarElementFromPage } from './getAvatarFromPage';

const POLOTNO_CLIPBOARD_KEY = 'polotno_clipboard';

const getClipboardItems = () => {
    const clipboard = localStorage.getItem(POLOTNO_CLIPBOARD_KEY);
    return JSON.parse(clipboard || '[]');
};

const handlePagePaste = (items: any, store: StoreType, isFocusOnTimeline: boolean) => {
    if (typeof items === 'string') {
        if (!isFocusOnTimeline) {
            return true;
        }

        const page = store.pages.find(p => p.id === items);
        if (page) {
            page.clone();
        } else {
            localStorage.removeItem(POLOTNO_CLIPBOARD_KEY);
        }
        return true;
    }
    return false;
};

export const shouldBlockAvatarPaste = (items: any, currentPage: Page) => {
    const isCopyAvatar =
        items.some((item: ElementType) => checkPolotnoType(item, polotnoTypes.Avatar)) ||
        items.some(
            (item: ElementType) =>
                item.type === 'group' && item.children.some((child: ElementType) => checkPolotnoType(child, polotnoTypes.Avatar))
        );
    const hasAvatar = !!getAvatarElementFromPage(currentPage);
    return isCopyAvatar && hasAvatar;
};

const handleClipboardPaste = (e: KeyboardEvent, store: StoreType, isFocusOnTimeline: boolean) => {
    if ((e.ctrlKey || e.metaKey) && e.key === 'v') {
        const items = getClipboardItems();
        if (handlePagePaste(items, store, isFocusOnTimeline)) return true;
        if (shouldBlockAvatarPaste(items, store.activePage)) return true;
    }
    return false;
};

const handleClipboardCopy = (e: KeyboardEvent, store: StoreType, isFocusOnTimeline: boolean) => {
    if (isFocusOnTimeline && !store.selectedElements?.length && (e.ctrlKey || e.metaKey) && e.key === 'c') {
        localStorage.setItem(POLOTNO_CLIPBOARD_KEY, JSON.stringify(store.activePage.id));
        return true;
    }
    return false;
};

const handlePageDuplication = (e: KeyboardEvent, store: StoreType, isFocusOnTimeline: boolean) => {
    if (isFocusOnTimeline && !store.selectedElements?.length && (e.ctrlKey || e.metaKey) && e.key === 'd') {
        e.preventDefault();
        store.activePage.clone();
        return true;
    }
    return false;
};

const handlePageDeletion = (e: KeyboardEvent, store: StoreType, isFocusOnTimeline: boolean) => {
    if (isFocusOnTimeline && !store.selectedElements?.length && (e.key === 'Delete' || e.key === 'Backspace') && store.pages.length > 1) {
        store.deletePages([store.activePage.id]);
        return true;
    }
    return false;
};

export const onKeyDownHandler = (e: KeyboardEvent, store: StoreType, isFocusOnTimeline: boolean) => {
    if (handleClipboardPaste(e, store, isFocusOnTimeline)) return;
    if (handleClipboardCopy(e, store, isFocusOnTimeline)) return;
    if (handlePageDuplication(e, store, isFocusOnTimeline)) return;
    if (handlePageDeletion(e, store, isFocusOnTimeline)) return;
    handleHotkey(e, store);
};
